import { render, staticRenderFns } from "./ProductMarketplacesPublish.vue?vue&type=template&id=dc3a9b1a"
import script from "./ProductMarketplacesPublish.vue?vue&type=script&lang=js"
export * from "./ProductMarketplacesPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports